import { useMutation } from '@tanstack/react-query';

import { TCreatePrototypeDto, useAvApi } from '@app-velocity/av-api-v2';

export const useCreateGuestScenarioMutation = (
  workspaceId?: string,
  signal?: AbortSignal
) => {
  const { guestPrototypes } = useAvApi();

  return useMutation({
    mutationKey: ['create-scenario-mutation'],
    mutationFn: async (body: TCreatePrototypeDto) => {
      if (!workspaceId) return;

      const res = await guestPrototypes.postV2GuestPrototypesByProjectId(
        body,
        {
          projectId: workspaceId,
        },
        {
          signal,
        }
      );

      return res.data;
    },
  });
};
